module.exports = __webpack_public_path__ + "/login_ui/img/cw-420d655fda2baae750e1a41d6e2ebb42.svg";